import { addPopupAction, LAYER } from '@core/js/components/common/PopupManager';
import { actionTypes } from './constants';
import uuid from 'uuid-random';
import SmsVerification from '@theme/js/components/main/SmsVerification';
import { STEPS_NAME } from '@theme/js/components/main/SmsVerification/constants';

export {
    toggleIsAppInitExecuted, fetchApp, updateHeaderHeight,
    setIsQuickDepositAvailable, addTags, toggleReconnectVisible, updateMenuItems,
    setConfigurationAction, toggleIsChangeLangInProgress, updateOldGamesFeeds,
    updateSportsbookRootURL, setIsIntegrationScriptLoadedAction
} from '@core/js/components/system/App/store/actions';

export const showSMSVereficationDrawerStep = (verificationType: string = 'default') => ({
    type: actionTypes.SHOW_SMS_VEREFICATION_DRAWER_STEP,
    payload: verificationType
});

export const hideSMSVereficationDrawerStep = () => ({
    type: actionTypes.HIDE_SMS_VEREFICATION_DRAWER_STEP
});

export const showSmsVerificationPopupAction = (data: { step: string, verificationType: string | undefined }) =>
    data.step === STEPS_NAME.DRAWER
        ? showSMSVereficationDrawerStep(data.verificationType)
        : addPopupAction({
            id: uuid(),
            layer: LAYER.HIGH_PRIORITY,
            component: SmsVerification,
            ...data
        });
